/** @format */

import {Box, Button, IconButton} from '@mui/material';
import {styled} from '@mui/material/styles';

export const Body = styled(Box)(({theme}) => ({
  display: 'flex',
  flexDirection: 'column',
  alignItems: 'center',
  gap: theme.spacing(4),
  padding: theme.spacing(4),
  width: '600px',
  background: theme.palette.semantic_light?.surface.background,
}));

export const StepperLabel = styled(Box)(({theme}) => ({
  fontSize: '18px',
  lineHeight: '22px',
  fontWeight: 400,
  color: theme.palette.semantic_light?.surface.onSurface,
}));

export const StepperRow = styled(Box)(({theme}) => ({
  display: 'flex',
  alignItems: 'stretch',
  borderRadius: theme.spacing(2),
  overflow: 'hidden',
  width: '200px',
}));

export const StepperButton = styled(IconButton)(({theme}) => ({
  borderRadius: 0,
  padding: theme.spacing(3.5, 4),
  backgroundColor: theme.palette.semantic_light?.primary.main,
  color: theme.palette.semantic_light?.primary.on,
  '&:hover': {
    backgroundColor: theme.palette.semantic_light?.primary.hover,
  },
  '&.Mui-disabled': {
    backgroundColor: theme.palette.semantic_light?.disabled.disabledLow,
    color: theme.palette.semantic_light?.disabled.disabled,
  },
}));

export const CountInput = styled(Box)(({theme}) => ({
  flex: 1,
  textAlign: 'center',
  fontSize: '18px',
  lineHeight: '22px',
  border: 'none',
  outline: 'none',
  borderTop: `1px solid ${theme.palette.semantic_light?.primary.active}`,
  borderBottom: `1px solid ${theme.palette.semantic_light?.primary.active}`,
  background: 'transparent',
  width: '100%',
  color: theme.palette.semantic_light?.surface.onSurface,
  padding: 0,
  '&::-webkit-outer-spin-button, &::-webkit-inner-spin-button': {
    appearance: 'none',
    margin: 0,
  },
  '&:disabled': {
    color: theme.palette.semantic_light?.disabled.disabled,
  },
}));

export const PriceBlock = styled(Box)(({theme}) => ({
  display: 'flex',
  alignItems: 'stretch',
  border: `1px solid ${theme.palette.semantic_light?.surface.surface3}`,
  borderRadius: theme.spacing(2),
}));

export const PriceCell = styled(Box)(({theme}) => ({
  display: 'flex',
  flexDirection: 'column',
  gap: theme.spacing(1),
  padding: theme.spacing(4),
  whiteSpace: 'nowrap',
}));

export const PriceDivider = styled(Box)(({theme}) => ({
  width: '1px',
  alignSelf: 'stretch',
  backgroundColor: theme.palette.semantic_light?.surface.surface3,
}));

export const PriceLabel = styled(Box)(({theme}) => ({
  fontSize: '14px',
  lineHeight: '16px',
  color: theme.palette.semantic_light?.surface.onSurface,
  whiteSpace: 'nowrap',
}));

export const PriceValue = styled(Box)(({theme}) => ({
  fontSize: '32px',
  lineHeight: '36px',
  color: theme.palette.semantic_light?.surface.onSurface,
  whiteSpace: 'nowrap',
}));

export const Footer = styled(Box)(({theme}) => ({
  display: 'flex',
  padding: theme.spacing(4),
  width: '100%',
  background: theme.palette.semantic_light?.surface.surface1,
}));

export const PayButtonGroup = styled(Box)(({theme}) => ({
  display: 'flex',
  gap: '1px',
  width: '100%',
  borderRadius: theme.spacing(2),
  overflow: 'hidden',
}));

export const PayButton = styled(Button)(({theme}) => ({
  flex: 1,
  borderRadius: 0,
  minHeight: '48px',
  display: 'flex',
  gap: theme.spacing(2),
  padding: theme.spacing(3.5, 4),
  fontSize: '16px',
  lineHeight: '20px',
  textTransform: 'none',
  backgroundColor: theme.palette.semantic_light?.primary.main,
  color: theme.palette.semantic_light?.primary.on,
  '&:hover': {
    backgroundColor: theme.palette.semantic_light?.primary.hover,
  },
  '&.Mui-disabled': {
    backgroundColor: theme.palette.semantic_light?.disabled.disabledLow,
    color: theme.palette.semantic_light?.disabled.disabled,
  },
}));

export const SuccessHeadline = styled(Box)(({theme}) => ({
  display: 'flex',
  alignItems: 'center',
  gap: theme.spacing(2),
  color: theme.palette.semantic_light?.good.main,
}));

export const SuccessIcon = styled(Box)(() => ({
  '&.material-symbols-outlined': {
    fontSize: '38px',
  },
}));

export const SuccessTitle = styled(Box)(({theme}) => ({
  fontSize: '32px',
  fontWeight: 500,
  color: theme.palette.semantic_light?.good.main,
}));

export const SuccessDescription = styled(Box)(({theme}) => ({
  fontSize: '16px',
  lineHeight: '20px',
  color: theme.palette.semantic_light?.surface.onSurface,
  textAlign: 'center',
}));

export const CloseButton = styled(Button)(({theme}) => ({
  flex: 1,
  borderRadius: theme.spacing(2),
  minHeight: '48px',
  textTransform: 'none',
  fontSize: '16px',
  lineHeight: '20px',
  backgroundColor: theme.palette.semantic_light?.good.main,
  color: theme.palette.semantic_light?.good.on,
  '&:hover': {
    backgroundColor: theme.palette.semantic_light?.good.hover,
  },
}));
